import { useMutation } from "@tanstack/react-query";
import { IMergeInvoiceWithScopePdfPayload, mergeInvoiceWithScopePdf } from "../actions/mergeInvoiceWithScopePdf";

export const useMergeInvoiceWithScopePdf = () => {
  return useMutation({
    mutationFn: (payload: IMergeInvoiceWithScopePdfPayload) => mergeInvoiceWithScopePdf(payload),
  });
};
